import '@/commons';
import Vue from 'vue';
import store from '@/store';
import { onMounted, ref } from '@vue/composition-api';
import { Debug } from '@/shared/utils/helpers';
import vuetify from '@/config/plugins/vuetify';
import Footer from '@/layout/footer';
import Menu from '@/layout/menu';
import { toggles } from '@/observable';
import Carga from '@/layout/carga';

const carga = Carga;
const footer = Footer;
const menu = Menu;

const Blog = Vue.extend({
  setup() {
    const toggleForm = () => {
      store.commit('toggleContactForm');
    };
    const toggleMenu = () => {
      toggles.menu = !toggles.menu;
    };
    onMounted(() => {
      setTimeout(() => {
        toggles.listo = !toggles.listo;
        AOS.init();
      }, 2000);
    });
    return {
      toggleMenu,
      toggleForm,
    };
  },
});
export default new Blog({
  el: '#blog',
  vuetify,
  delimiters: ['[{', '}]'],
});
